import { VehicleFilters } from "../features/Filters/VehicleFilters";

export const ArchivedVehiclesActions = () => {
  return (
    <div className="mt-2">
      <VehicleFilters.ActiveFilters />
    </div>
  );
};
